import React, { useState } from 'react';

interface NavContextInterface {
    activeNavLinkId: string,
    setActiveNavLinkId: React.Dispatch<React.SetStateAction<string>>
}


interface Props {
    children: React.ReactNode
}

export const NavContext = React.createContext<NavContextInterface>({
    activeNavLinkId: "",
    setActiveNavLinkId: () => { }
});

const NavProvider = ({ children }: Props) => {
    const [activeNavLinkId, setActiveNavLinkId] = useState('');

    return (
        <NavContext.Provider value={{
            activeNavLinkId,
            setActiveNavLinkId
        }}>
            {children}
        </NavContext.Provider>
    );
};

export default NavProvider;